function initialState () {
  return {
    token: null,
    user: null
  }
}

export default {
  namespaced: true,

  state: initialState,

  mutations: {
    reset (state) {
      const initial = initialState()
      Object.keys(initial).forEach(key => state[key] = initial[key])
    },

    setToken (state, token) {
      state.token = token
    },

    setUser (state, user) {
      state.user = user
    }
  },

  actions: {
    reset ({ commit }) {
      commit('reset')
    },

    setToken ({ commit }, token) {
      commit('setToken', token)
    },

    setUser ({ commit }, user) {
      commit('setUser', user)
    }
  },

  getters: {
    authenticated (state) {
      return state.token !== null && state.user !== null
    },

    setToken (state) {
      return state.token
    },

    getUser (state) {
      return state.user
    },

    isAdmin (state) {
      return state.user && state.user.role === 'ADM'
    }
  }
}
